import { debugLog } from 'shared/logger/debugLog';
import { LogLevel } from 'shared/types/logger';
import { appLog } from './appLog';
import { provideLogInfo } from './provideLogInfo';

export const logInfo = (
  message: string,
  errorObjectWithPotentiallySensitiveData?: object | null,
  addTimestamp?: boolean
): void => {
  const additionalInfo = provideLogInfo();
  const dataWithTimestamp = addTimestamp
    ? {
        ...(errorObjectWithPotentiallySensitiveData || {}),
        timestamp: new Date().toISOString(),
      }
    : errorObjectWithPotentiallySensitiveData;
  debugLog(
    message,
    LogLevel.INFO,
    additionalInfo,
    dataWithTimestamp
  );
  appLog(
    message,
    LogLevel.INFO,
    additionalInfo,
    dataWithTimestamp
  );
};
